import { createContext, useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { ModalDialogProps } from '../ModalDialog/ModalDialog';

export const defaultDialogContext: {
  use: ModalDialogProps['use'];
  headerCallback: Function;
  inDialog?: boolean;
} = {
  use: 'default',
  headerCallback: emptyFunction,
  inDialog: false,
};

export const DialogContext = createContext(defaultDialogContext);

const { Provider } = DialogContext;

export { Provider as DialogContextProvider };

export const useDialogContext = () => {
  const context = useContext(DialogContext);
  return context;
};
